import { css } from '@emotion/react';
import { forwardRef } from 'react';

import { SectionDisplay } from '@/components/rehearsal/section-display';
import { darkTheme } from '@/theme/dark-theme';

export interface RehearsalSection {
  title: string | null;
  content: string;
  position: number;
  speakerNotes?: string[];
}

export interface RehearsalScriptDisplayProps {
  sections: RehearsalSection[];
  currentSectionIndex: number;
  fontSize: number;
  cursorPosition?: number;
  sectionBoundaries?: number[];
  lineWidth?: number;
  headerOffset?: number;
  onWordClick?: (wordIndex: number) => void;
}

export const RehearsalScriptDisplay = forwardRef<HTMLDivElement, RehearsalScriptDisplayProps>(
  function RehearsalScriptDisplay(
    {
      sections,
      currentSectionIndex,
      fontSize,
      cursorPosition,
      sectionBoundaries,
      lineWidth,
      headerOffset = 0,
      onWordClick,
    },
    ref,
  ) {
    return (
      <div
        ref={ref}
        data-testid="rehearsal-scroll-container"
        css={css`
          flex: 1;
          overflow-y: auto;
          position: relative;
          background: ${darkTheme.background};
          color: ${darkTheme.text};

          ${headerOffset > 0 ? `padding-top: ${headerOffset}px;` : ''}

          /* Hide scrollbar */
          scrollbar-width: none;
          &::-webkit-scrollbar {
            display: none;
          }
        `}
      >
        <div
          css={css`
            height: 50vh;
          `}
        />
        {sections.map((section, i) => (
          <SectionDisplay
            key={section.position}
            content={section.content}
            speakerNotes={section.speakerNotes}
            position={section.position}
            isCurrent={i === currentSectionIndex}
            showDivider={i > 0}
            onClick={() => {}}
            fontSize={fontSize}
            cursorOffset={sectionBoundaries?.[i]}
            cursorPosition={cursorPosition}
            lineWidth={lineWidth}
            onWordClick={onWordClick}
          />
        ))}
        <div
          css={css`
            height: 50vh;
          `}
        />
      </div>
    );
  },
);
